import React from 'react'
import moment from 'moment'
import './Summary.css'
import Card from '../core/Card'
import { connect } from 'react-redux'
import numeral from 'numeral';
import { DatePicker, Row, Col } from 'antd';
import {updateRange} from './actions'
import twix from 'twix'
import styled, {keyframes} from 'styled-components'

// keyframes returns a unique name based on a hash of the contents of the keyframes
const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;

const SummaryCard = styled(Card)`
  > span {
    display: flex;
    justify-content: space-between;
    margin-bottom: 4vw;
  }
  .title {
    font-size: 16px;
    text-transform: uppercase;
  }
  > span, > div {
    animation-duration: 0.5s;
    animation-name: ${props=>props.isFetchingTotals ? fadeOut : fadeIn};
    opacity: ${props=>props.isFetchingTotals ? 0 : 1};
  }

  grid-area: Summary;
  padding: 20px;

  h1 {
    text-transform: uppercase;
    font-size: 18px;
    line-height: 1em;
    padding: 0;
    margin: 0;
  }
  div {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    div {
      align-self: center;
      display: flex;
      flex-direction: column;
      text-transform: uppercase;
      text-align: center;
      span {
        font-size: 26px;
        color: #31B59F;
      }
    }
  }

  > div {
    display: flex;
    h3 {
      font-size: 40px;
      font-weight: 700;
      margin-top: 0px;
      margin-bottom: 5px;
    }
  }

`

const Summary = connect( ({trips, models})=>({
    ...trips,
    kms_enabled: models.user.kms_enabled,
    mType: models.user.kms_enabled ? 'kms' : 'miles',
    // range: trips.filterValues.range.length>0 ? trips.filterValues.range : rangePickerRanges['YTD'],
    totals: trips.totals.filtered_totals || trips.totals,
    title: trips.filterValues.range.length>0
      ? `${
        moment(trips.filterValues.range[0])
        .twix(
          trips.filterValues.range[1]
        ).format({
          hideTime: true,
          monthFormat: 'MMM',
          dayFormat: 'Do'
        })
      }`
      : 'This Year'
  })
)( ({isFetchingTotals, totals, kms_enabled, mType, title}) =>
  <SummaryCard
    // showLoadingIcon={isFetchingTotals}
    isFetchingTotals={isFetchingTotals}
    className="Summary" gridArea="Summary">
    <span className="title">
        {title}
    </span>

    <div>
      <div>
        <h3>{numeral(totals['total_'+mType]).format('(0,0)')}</h3>
        {kms_enabled? 'Kilometres' : 'Miles'}
      </div>
      <div>
        <h3 style={{color: "#31b59f"}}>
          {numeral(Math.abs(totals.total_trips_deductions)).format('($0,0)')}
        </h3>Deductions
      </div>

      {
        totals['total_uncategorized_'+mType] &&
        <div>
          <h3>{numeral(totals['total_uncategorized_'+mType]).format('(0,0)')}</h3>
          Unclassified {kms_enabled? 'km' : 'miles'}
        </div>
      }

    </div>

    {/* <Row type="flex" justify="space-around">
      <Col span={8}>
        <h3>{numeral(totals['total_'+mType]).format('(0,0)')}</h3>
        {kms_enabled? 'Kilometres' : 'Miles'}
      </Col>
      <Col span={8}>
        <h3 style={{color: "#31b59f"}}>
          {numeral(Math.abs(totals.total_trips_deductions)).format('($0,0)')}
        </h3>Deductions
      </Col>

      {
        totals['total_uncategorized_'+mType] &&
        <Col span={8}>
          <h3>{numeral(totals['total_uncategorized_'+mType]).format('(0,0)')}</h3>
          Unclassified {kms_enabled? 'km' : 'miles'}
        </Col>
      }
    </Row> */}
  </SummaryCard>
)

export default Summary



// WEBPACK FOOTER //
// ./src/trips/Summary.js